import classNames from 'classnames';
import { Address } from './common.types';
import { NoValue } from './NoValue';

type AddressDetailsProps = {
    readonly address: Partial<Address>;
    readonly identifier?: string;
};

export const AddressDetails = ({ address, identifier }: AddressDetailsProps) => {
    const { name, street, postalCode, city, countryCode } = address;
    const hasAddressDetails = street || postalCode || city || countryCode;
    const isEmptyAddress = !(identifier || name || hasAddressDetails);

    return isEmptyAddress ? (
        <NoValue />
    ) : (
        <div>
            {name && (
                <div className={classNames('text-medium', { 'margin-bottom-10': !identifier && hasAddressDetails })}>
                    {name}
                </div>
            )}
            {identifier && (
                <div className={classNames('text-size-14', { 'margin-bottom-10': hasAddressDetails })}>
                    {identifier}
                </div>
            )}
            {street && <div>{street}</div>}
            {(postalCode || city) && (
                <div>
                    <span className="margin-right-5">{postalCode}</span>
                    <span>{city}</span>
                </div>
            )}
            {countryCode && <div>{countryCode}</div>}
        </div>
    );
};
